import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { OrderModel } from 'src/app/models/order.model';
import { IPayment } from 'src/app/models/payment.model';
import { ProfileModel } from 'src/app/models/profile.model';
import { DataService } from 'src/app/services/data/data.service';
import { MathService } from 'src/app/services/math/math.service';
import { PaymentService } from 'src/app/services/payment/payment.service';
import { CashInComponent } from '../cash-in/cash-in.component';

@Component({
  selector: 'payments-list',
  templateUrl: './payments-list.component.html',
  styleUrls: ['./payments-list.component.scss'],
})
export class PaymentsListComponent implements OnInit {

  @Input()
  title:string;

  @Input()
  mode:string // edit, view, order, catalog, sale

  @Input()
  loading:boolean = false;

  @Input()
  disabled:boolean = false;

  @Input()
  order:OrderModel;

  @Input()
  items:IPayment[];

  @Input()
  sortBy:string

  @Input()
  owner:ProfileModel;

  constructor(private dataService:DataService, private paymentService:PaymentService,
    public mathService:MathService,
    private modalCtrl:ModalController) {

  }

  ngOnInit(){

  }

  async openPayment(item:IPayment){
    const modal = await this.modalCtrl.create({
      component: CashInComponent,
      presentingElement:await this.modalCtrl.getTop(),
      cssClass: 'small-modal',
      componentProps:{
        order:this.order,
        payment: item,
        onValidate: async (payment:any) => {
          if(payment.key){
            await this.updateOrderPayment(this.order,payment);
            this.order.payments[payment.key] = payment;
            this.paymentService.updatePaymentStatus(this.order);
          }
          else{
            const paymentResult = await this.dataService.createOrderPayment(this.order,payment);
            if(!this.order.payments){
              this.order.payments = {};
            }
            payment.key = paymentResult.key;
            this.order.payments[paymentResult.key] = payment;
            this.paymentService.updatePaymentStatus(this.order);
            console.log(this.order);
          }
          modal.dismiss();
        },
        onDelete: async (payment:IPayment) => {
          await this.dataService.deletePayment(payment, this.order);
          modal.dismiss();
          delete this.order.payments[payment.key];
          this.paymentService.updatePaymentStatus(this.order);
        }
      }
    });
    return await modal.present();  
  }

  async updateOrderPayment(order:OrderModel, payment:IPayment){
    await this.dataService.updateOrderPayment(order,payment);
    await this.paymentService.changeOrderPaymentStatus(order,order.tournee,order.tournee.producer,order.paymentStatus);
  }

  async addPayment(){
    const payment:IPayment = {
      mode:'cash',
      debitedFunds:{
        amount:(this.order.finances.totals.sold - (this.order.finances.totals.paid||0))
    }};
    this.openPayment(payment);
  }

  sendReminder(){
    const payment:IPayment = {
      mode:'transfer',
      // bankAccount:this.order.tournee.details.paymentModes
      debitedFunds:{
        amount:(this.order.finances.totals.sold - (this.order.finances.totals.paid||0))
    }};
    this.paymentService.sendPaymentReminderByEmail(payment,this.order);
  }

}
